import { cva } from '@/styled-system/css';

export const upsellBannerBodyRecipe = cva({
  base: {
    'display': {
      lg: 'inline',
    },
    'marginBlockStart': {
      lgDown: 'none',
    },
    'marginInlineStart': {
      lg: 'tightest',
    },

    '& > [data-c11n-component="Text"]': {
      color: 'inherit',
      textStyle: 'body',
      display: {
        lg: 'inline',
      },
    },
    '& > [data-c11n-component="Paragraph"]': {
      color: 'inherit',
      textStyle: 'body',
      display: {
        lg: 'inline',
      },
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.neutral',
      },
      soft: {
        color: 'text.neutral',
      },
      hero: {
        color: 'text.onHero.neutral',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
